//供应商
import operHome from '@/components/oper/home.vue'
//供应商
import operOperHome from '@/components/oper/oper/home.vue'
import operOperUpdate from '@/components/oper/oper/update.vue'
//员工信息
import operEmpHome from '@/components/oper/emp/home.vue'
import operEmpList from '@/components/oper/emp/list.vue'
import operEmpAdd from '@/components/oper/emp/add.vue'
import operEmpUpdate from '@/components/oper/emp/update.vue'
//设备信息
import operMacHome from '@/components/oper/mac/home.vue'
import operMacList from '@/components/oper/mac/list.vue'
import operMacEmpUpdate from '@/components/oper/mac/updateEmp.vue'
import operMacUpdatePhone from '@/components/oper/mac/updatePhone.vue'
//货道信息
import operMacAisleHome from '@/components/oper/mac/aisle/home.vue'
import operMacAisleList from '@/components/oper/mac/aisle/list.vue'
import operMacAisleList11 from '@/components/oper/mac/aisle/list11.vue'
import operMacAisleUpdate from '@/components/oper/mac/aisle/update.vue'

//商品
import operCommodityHome from '@/components/oper/commodity/home.vue'
//商品类型
import operCommodityTypeHome from '@/components/oper/commodity/type/home.vue'
import operCommodityTypeList from '@/components/oper/commodity/type/list.vue'
import operCommodityTypeList2 from '@/components/oper/commodity/type/list2.vue'
import operCommodityTypeAdd from '@/components/oper/commodity/type/add.vue'
import operCommodityTypeUpdate from '@/components/oper/commodity/type/update.vue'

//商品信息
import operCommodityCommHome from '@/components/oper/commodity/comm/home.vue'
import operCommodityCommList from '@/components/oper/commodity/comm/list.vue'
import operCommodityCommAdd from '@/components/oper/commodity/comm/add.vue'
import operCommodityCommUpdate from '@/components/oper/commodity/comm/update.vue'
//商品出入库信息
import operCommodityRepertoryHome from '@/components/oper/commodity/repertory/home.vue'
import operCommodityRepertoryList from '@/components/oper/commodity/repertory/list.vue'
import operCommodityRepertoryAdd from '@/components/oper/commodity/repertory/add.vue'
import operCommodityRepertoryDelete from '@/components/oper/commodity/repertory/delete.vue'
import operCommodityRepertoryDetails from '@/components/oper/commodity/repertory/details.vue'
//报表信息
import operCommodityFinanceHome from '@/components/oper/finance/home.vue'
import operCommodityFinanceList from '@/components/oper/finance/list.vue'
import operCommodityFinanceMacList from '@/components/oper/finance/listMac.vue'


//片区信息
import operEmpDistrictHome from '@/components/oper/district/home.vue'
import operEmpDistrictList from '@/components/oper/district/list.vue'
import operEmpDistrictAdd from '@/components/oper/district/add.vue'
import operEmpDistrictUpdate from '@/components/oper/district/update.vue'


//统计信息
import operCommodityFinanceTongjiHome from '@/components/oper/finance/tongji/home.vue'
import operCommodityFinanceTongjiList from '@/components/oper/finance/tongji/commList.vue'
import operCommodityFinanceTypeTongjiList from '@/components/oper/finance/tongji/commTypeList.vue'
//报表信息
import operBaobiaoHome from '@/components/oper/finance/baobiao/home.vue'
import operBaobiaoList from '@/components/oper/finance/baobiao/heji.vue'
import operBaobiaoYear from '@/components/oper/finance/baobiao/year.vue'
import operBaobiaoMonth from '@/components/oper/finance/baobiao/month.vue'
import operBaobiaoDay from '@/components/oper/finance/baobiao/day.vue'
// 销售报表导出
import operCommodityFinanceDaochu from '@/components/oper/finance/daochu/home.vue'
import exportsalesreport from '@/components/oper/finance/daochu/exportsalesreport.vue'

export default [{
	path: 'oper',
	name: 'oper',
	component: operHome,
	children: [{ //供应商信息
		path: 'oper',
		name: 'oper',
		component: operOperHome,
		children: [{
			path: 'update',
			name: 'oper/oper/update',
			component: operOperUpdate
		}]
	}, { //员工信息
		path: 'emp',
		name: 'emp',
		component: operEmpHome,
		children: [{
			path: 'list',
			name: 'oper/emp/list',
			component: operEmpList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'add',
			name: 'oper/emp/add',
			component: operEmpAdd
		}, {
			path: 'update',
			name: 'oper/emp/update',
			component: operEmpUpdate
		}, ]
	}, { //设备信息
		path: 'mac',
		name: 'mac',
		component: operMacHome,
		children: [{
			path: 'list',
			name: 'oper/mac/list',
			component: operMacList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'update',
			name: 'oper/mac/emp/update',
			component: operMacEmpUpdate
		}, {
			path: 'update/phone',
			name: 'oper/mac/update/phone',
			component: operMacUpdatePhone
		},]
	}, { //货道信息
		path: 'mac/aisle',
		name: 'mac/aisle',
		component: operMacAisleHome,
		children: [{
			path: 'list',
			name: 'oper/mac/aisle/list',
			component: operMacAisleList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list11',
			name: 'oper/mac/aisle/list11',
			component: operMacAisleList11
		}, {
			path: 'update',
			name: 'oper/mac/aisle/update',
			component: operMacAisleUpdate
		}]
	}, { //商品类型
		path: 'comm/type',
		name: 'comm/type',
		component: operMacAisleHome,
		children: [{
			path: 'list',
			name: 'oper/comm/type/list',
			component: operCommodityTypeList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'list2',
			name: 'oper/comm/type/list2',
			component: operCommodityTypeList2,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'update',
			name: 'oper/comm/type/add',
			component: operCommodityTypeAdd
		}, {
			path: 'update',
			name: 'oper/comm/type/update',
			component: operCommodityTypeUpdate
		}]
	}, { //商品详情
		path: 'comm',
		name: 'comm',
		component: operCommodityCommHome,
		children: [{
			path: 'list',
			name: 'oper/comm/list',
			component: operCommodityCommList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'update',
			name: 'oper/comm/add',
			component: operCommodityCommAdd
		}, {
			path: 'update',
			name: 'oper/comm/update',
			component: operCommodityCommUpdate
		}]
	}, { //商品出入库管理
		path: 'repertory',
		name: 'repertory',
		component: operCommodityRepertoryHome,
		children: [{
			path: 'list',
			name: 'oper/repertory/list',
			component: operCommodityRepertoryList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'add',
			name: 'oper/repertory/add',
			component: operCommodityRepertoryAdd
		}, {
			path: 'delete',
			name: 'oper/repertory/delete',
			component: operCommodityRepertoryDelete
		}, {
			path: 'details',
			name: 'oper/repertory/details',
			component: operCommodityRepertoryDetails
		}]
	}, { //报表管理
		path: 'finance',
		name: 'finance',
		component: operCommodityFinanceHome,
		children: [{
			path: 'list',
			name: 'oper/finance/list',
			component: operCommodityFinanceList,
			
		},{
			path: 'list/mac',
			name: 'oper/finance/list/mac',
			component: operCommodityFinanceMacList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}]
	}, { //片区信息
		path: 'district',
		name: 'district',
		component: operEmpDistrictHome,
		children: [{
			path: 'list',
			name: 'oper/district/list',
			component: operEmpDistrictList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}, {
			path: 'add',
			name: 'oper/district/add',
			component: operEmpDistrictAdd
		}, {
			path: 'update',
			name: 'oper/district/update',
			component: operEmpDistrictUpdate
		}, ]
	},{ //报表管理
		path: 'finance/tongji',
		name: 'finance/tongji',
		component: operCommodityFinanceTongjiHome,
		children: [{
			path: 'list1',
			name: 'oper/finance/tongji/list1',
			component: operCommodityFinanceTongjiList,
		},{
			path: 'list2',
			name: 'oper/finance/tongji/list2',
			component: operCommodityFinanceTypeTongjiList
		}]
	},
	{//销售报表导出
		path:'daochu',
		name:'daochu',
		component:operCommodityFinanceDaochu,
		children:[{
			path: 'exportsalesreport',
			name: 'oper/finance/daochu/exportsalesreport',
			component: exportsalesreport
		}]
	},
	{ 
		path: 'baobiao',
		name: 'baobiao',
		component: operBaobiaoHome,
		children: [{
			path: 'list/hj',
			name: 'oper/baobiao/list/hj',
			component: operBaobiaoList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/year',
			name: 'oper/baobiao/list/year',
			component: operBaobiaoYear,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/month',
			name: 'oper/baobiao/list/month',
			component: operBaobiaoMonth,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list/day',
			name: 'oper/baobiao/list/day',
			component: operBaobiaoDay,
			meta: {
				 keepAlive: true // 需要缓存
			}
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/oper/oper.js